// extracted by mini-css-extract-plugin
module.exports = {"titleHeader":"LegalDocs_titleHeader__lqbQ8","versionDropdown":"LegalDocs_versionDropdown__tKDEM","customList":"LegalDocs_customList__UrtKf"};